import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20fashion%20lifestyle%20scene%20with%20scattered%20editorial%20magazines%20open%20on%20a%20light%20oak%20coffee%20table%2C%20a%20steaming%20ceramic%20mug%20of%20matcha%20latte%2C%20a%20tablet%20displaying%20colorful%20product%20catalog%20interface%2C%20raw%20silk%20curtains%20billowing%20gently%20in%20breeze%2C%20soft%20morning%20sunlight%20streaming%20through%20large%20windows%2C%20warm%20cream%20sage%20and%20blush%20pink%20color%20harmony%2C%20sophisticated%20loft%20interior%20with%20exposed%20beams%2C%20plants%20casting%20organic%20shadows%2C%20aspirational%20creative%20workspace%20atmosphere%2C%20no%20people%20visible%2C%20high%20end%20editorial%20photography%20style&width=1600&height=900&seq=hero-v3-fresh-2026&orientation=landscape"
          alt="Oopbuy Spreadsheet Shopping Guide"
          title="Oopbuy Spreadsheet – Mode und Lifestyle Einkaufsguide"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-24 text-center max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/90 text-foreground-700 text-sm font-medium mb-8">
          <i className="ri-sparkling-line w-4 h-4 flex items-center justify-center"></i>
          <span>Nr. 1 Oopbuy Spreadsheet Guide in Deutschland</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          Oopbuy Spreadsheet – Die beste deutsche &Uuml;bersicht f&uuml;r gepr&uuml;fte Produkte, Verk&auml;ufer und Einkaufslisten
        </h1>

        <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Finde die besten Produkte, Verk&auml;ufer und Kategorien mit unserem aktuellen Oopbuy Spreadsheet Guide.
          Vergleiche Angebote, entdecke beliebte Artikel und erfahre, wie du sicher und effizient einkaufst.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105"
          >
            <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center"></i>
            Oopbuy Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/95 text-foreground-900 font-semibold text-base hover:bg-white transition-all duration-300 hover:scale-105"
          >
            <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
            <span>Aktualisierte Spreadsheet Listen</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
            <span>Deutsche Erkl&auml;rung</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
            <span>Verk&auml;ufer Vergleich</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
            <span>QC &amp; Sicherheits Tipps</span>
          </div>
        </div>
      </div>
    </section>
  );
}